import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import Loader from "react-loader-spinner";
import { useIntercom } from "react-use-intercom";
import SideBar from "../../Sections/SideBar";
import Navbar from "../../Sections/NavBar";
import MobileNav from "../../Sections/MobileNav";

import { useSelector, useDispatch } from "react-redux";
import { setUser } from "../../../app-store/userSlice";
import InitiateTransfer from "./InitiateTransfer";
import ConfirmPurchase from "./ConfirmPurchase";
import Status from "./Status";
import httpClient from "../../../custom-hooks/httpClient";
import TwoFactorAuth from "../../2FA-OTP";

function PaymentElectricity() {
  const userId = localStorage.getItem("id");
  const user = useSelector((state) => state.user.user);

  const dispatch = useDispatch();

  const { boot } = useIntercom();

  const [stage, setStage] = useState("initiate"); // initiate, confirm, status
  const [transferDetails, setTransferDetails] = useState({
    transaction_pin: "",
    phone_number: "",
    amount: "",
    meter_number: "",
    service_type: "",
    wallet_account_number: "",
    account_details: "",
    wallet_name: "",
  });

  const [bankName, setBankName] = useState("");
  const [transferStatus, setTransferStatus] = useState("");
  const [transferReference, setTransferReference] = useState("");
  const [isProcessing, setIsProcessing] = useState(false);
  const [notificationChannel, setNotificationChannel] = useState("");
  const [recipient, setRecipient] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const handleChangeTransferDetails = (e) => {
    if (e.target.name === "bank") {
      setTransferDetails({
        ...transferDetails,
        bank_code: e.target.value.split("***")[0],
      });
      setBankName(e.target.value.split("***")[1]);
    } else if (e.target.name === "wallet_account_number") {
      const selectedWallet = user.wallets.find(
        (wallet) => wallet.account_no === e.target.value,
      );
      if (selectedWallet) {
        setTransferDetails({
          ...transferDetails,
          wallet_account_number: selectedWallet.account_no,
          wallet_name: selectedWallet.name,
        });
      }
    } else {
      setTransferDetails({
        ...transferDetails,
        [e.target.name]: e.target.value,
      });
    }
  };

  const handleInitiateTransfer = (e) => {
    e.preventDefault();
    setStage("confirm");
  };

  const onConfirm = async (e) => {
    e.preventDefault();
    setIsProcessing(true);

    // Set transfer amount to number
    const transfer = {
      ...transferDetails,
      amount: Number(transferDetails.amount),
      phone_number: `234${transferDetails.phone_number}`,
    };

    try {
      const { status, data } = await httpClient.post(
        `/payments/categories/electricity/buy-electricity`,
        {
          ...transfer,
        }
      );

      if (status === 202) {
        setNotificationChannel(data.notificationChannel);
        setRecipient(data.recipient);
        setStage("authenticate");
      }
      if (status === 201) {
        setTransferReference(data.transaction.transactionRef);
        setTransferStatus("successful");
        setStage("status");
      }
    } catch (err) {
      setIsProcessing(false);
      toast.error(err.response.data.message);
      setTransferStatus("failed");
      setStage("status");
    }
  };

  const handleConfirmTransfer = async (e) => {
    e.preventDefault();
    setIsProcessing(true);
    // Set transfer amount to number
    const transfer = {
      ...transferDetails,
      amount: Number(transferDetails.amount),
      phone_number: `234${transferDetails.phone_number}`,
    };
    const otp = document.getElementById("otp").value; // Get OTP from user input.

    try {
      const { status, data } = await httpClient.post(
        `/payments/categories/electricity/buy-electricity`,
        {
          ...transfer,
          otp,
        }
      );

      setIsProcessing(false);
      if (status === 201) {
        setTransferStatus("successful");
        setTransferReference(data.transaction.transactionRef);
        setStage("status");
      }
    } catch (err) {
      // Check for 401 with "invalid otp" message
      if (
        err.response?.status === 401 &&
        err.response?.data?.message === "Invalid otp"
      ) {
        setErrorMessage("Invalid OTP! Please, check and try again.");
        document.getElementById("otp").value = ""; // Reset OTP input field.
        setIsProcessing(false);
        setTimeout(() => {
          setErrorMessage("");
        }, 5000);
      } else {
        const errorMessage =
        err.response && err.response.data
          ? err.response.data.message
          : "Error initiating electricity purchase";
        toast.error(errorMessage);
        setTransferStatus("failed");
        setStage("status");
      }
    } finally {
      setIsProcessing(false);
    }
  };

  useEffect(() => {
    httpClient
      .get(`/users/${userId}`)
      .then(({ status, data }) => {
        if (status === 200) {
          dispatch(setUser(data.user));
          boot({
            name: `${data.user.first_name} ${data.user.last_name}`,
          });
        }
      })
      .catch((err) => {
        // toast.error("Error getting user");
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!user) {
    return (
      <div
        className="text-center align-items-center"
        style={{ marginTop: "25%" }}
      >
        <Loader type="Oval" color="#1c743a" />
      </div>
    );
  }

  return (
    <>
      <Navbar dashboard />
      <MobileNav />
      <section>
        <div className="container-fluid">
          <div className="row">
            <SideBar />
            <div className="col-12 col-lg-6 col-xl-8 offset-lg-3 offset-xl-2 py-7 py-lg-9 px-lg-7">
              {stage === "initiate" && (
                <InitiateTransfer
                  user={user}
                  handleInitiateTransfer={handleInitiateTransfer}
                  handleChangeTransferDetails={handleChangeTransferDetails}
                  transferDetails={transferDetails}
                  bankName={bankName}
                  setBankName={setBankName}
                  setTransferDetails={setTransferDetails}
                />
              )}
              {stage === "confirm" && (
                <ConfirmPurchase
                  handleChangeTransferDetails={handleChangeTransferDetails}
                  transferDetails={transferDetails}
                  bankName={bankName}
                  isProcessing={isProcessing}
                  onConfirm={onConfirm}
                />
              )}
              {stage === "authenticate" && (
                <TwoFactorAuth
                  handleConfirmTransfer={handleConfirmTransfer}
                  notificationChannel={notificationChannel}
                  recipient={recipient}
                  errorMessage={errorMessage}
                />
              )}
              {stage === "status" && (
                <Status
                  transferDetails={transferDetails}
                  transferStatus={transferStatus}
                  transferReference={transferReference}
                  bankName={bankName}
                />
              )}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default PaymentElectricity;
